//const apiUrl = "https://api-server-cspaxy.chinacspa.com"
const apiUrl = "https://api-server-cspaxy.cspaxy.com"
//const apiUrl = "http://192.168.1.100:8034"
//const apiUrl = "http://127.0.0.1:8034"
const assoTypes = {
  1: "分支机构及附属机构",
  2: "省市自治区老教授协会",
  3: "高校及科研机构老教授协会",
  99: "中国老教授协会",
}
const uploadPictureNitice = {
  1: '图片尺寸为：宽<span class="red">1920px</span> 高<span class="red">240px</span>，图片内容区域宽度建议为<span class="red">1200px</span>',
  2: '图片尺寸为：宽<span class="red">790px</span> 高<span class="red">400px</span>',
  3: '图片尺寸为：宽<span class="red">380px</span> 高<span class="red">230px</span>',
  4: '图片尺寸为：宽<span class="red">380px</span> 高<span class="red">150px</span>',
}

export default {
  apiUrl,
  assoTypes,
  uploadPictureNitice,
}